import React from "react";
import OptionalTextAreaInput, { OptionalTextAreaInputProps } from "./OptionalTextAreaInput";
import { replaceNewLineWithBr } from "utilities/reactUtils";

const OptionalCodeAreaInput = (props: OptionalTextAreaInputProps) => {
  return <OptionalTextAreaInput
    {...props}
    style={{ fontFamily: "\"Courier New\", monospace", ...props.style }}
  />;
}

export const OptionalCodeAreaDetails = (props: { children: string }) => {
  return <div style={{
    fontFamily: "\"Courier New\", monospace"
  }}>
    {replaceNewLineWithBr(props.children)}
  </div>
}

export default OptionalCodeAreaInput;